const UECompensationSection = () => (
  <section id="compensation">
    <div className="section-inner">
      <div className="section-head">
        <span className="section-label">
          <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7H14a3.5 3.5 0 0 1 0 7H6" />
          </svg>
          What&apos;s in your pocket
        </span>
        <h2 className="section-title">Three income streams. One paycheck.</h2>
        <p className="section-lead">
          Hourly wage + a km bonus on every shift + 100% of your tips. Here&apos;s exactly what each
          one looks like:
        </p>
      </div>

      <div className="comp-grid">
        <div className="comp-card">
          <div className="comp-card-eyebrow">
            <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7H14a3.5 3.5 0 0 1 0 7H6" />
            </svg>
            Hourly wage by age
          </div>
          <table className="wage-table">
            <thead>
              <tr>
                <th>Age</th>
                <th className="r">Gross / hour</th>
              </tr>
            </thead>
            <tbody>
              <tr className="featured">
                <td>21 and up</td>
                <td className="rate">€16.19</td>
              </tr>
              <tr>
                <td>20</td>
                <td className="rate">€12.95</td>
              </tr>
              <tr>
                <td>19</td>
                <td className="rate">€9.71</td>
              </tr>
              <tr>
                <td>18</td>
                <td className="rate">€8.64</td>
              </tr>
              <tr>
                <td>17</td>
                <td className="rate">€7.16</td>
              </tr>
              <tr>
                <td>16</td>
                <td className="rate">€6.48</td>
              </tr>
            </tbody>
          </table>
          <p className="comp-note">
            Gross amounts before tax, including holiday allowance. Flink applies the rate that
            matches your age.
          </p>
        </div>

        <div className="comp-card km-card">
          <div className="comp-card-eyebrow">
            <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="5.5" cy="17.5" r="3.5" />
              <circle cx="18.5" cy="17.5" r="3.5" />
              <path d="M15 6h4l-2 6M5 17l5-10h4l3 6" />
            </svg>
            Km bonus per shift
          </div>

          <div className="km-row">
            <div className="km-icon">
              <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="5.5" cy="17.5" r="3.5" />
                <circle cx="18.5" cy="17.5" r="3.5" />
                <path d="M15 6h4l-2 6M5 17l5-10h4l3 6" />
              </svg>
            </div>
            <div className="km-text">
              <div className="km-label">On your bike</div>
              <div className="km-sub"></div>
            </div>
            <div className="km-rate">
              + €0.19<small>gross per km</small>
            </div>
          </div>

          <div className="km-row">
            <div className="km-icon">
              <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="7" cy="17" r="3" />
                <circle cx="17" cy="17" r="3" />
                <path d="M14 5h3v6H7l3 6M10 8h6" />
              </svg>
            </div>
            <div className="km-text">
              <div className="km-label">On a scooter</div>
              <div className="km-sub"></div>
            </div>
            <div className="km-rate">
              + €0.24<small>gross per km</small>
            </div>
          </div>

          <div className="week-projection">
            <div className="week-projection-eyebrow">Over a 30-hour week</div>
            <p>
              <strong>Bike:</strong> ~€40 extra / week — <strong>~€170 / month</strong>
              <br />
              <strong>Scooter:</strong> ~€50 extra / week — <strong>~€218 / month</strong>
            </p>
          </div>

          <p className="comp-note">
            Your vehicle, your responsibility. The km bonus on top of your wage helps cover
            maintenance costs.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default UECompensationSection;
